import axios from 'axios';
import { trackPromise } from 'react-promise-tracker';
import * as CommonVariables from '../../Common/CommonVariables';

export const UploadMTDExcel = async (formData) => {
  const result = await trackPromise(
    axios.post(
      CommonVariables.API_DOMAIN + `MetLink/Upload_MTD_Achievement_Excel`,
      formData,
      {
        ...CommonVariables.API_HEADER,
        headers: {
          ...CommonVariables.API_HEADER.headers,
          "Content-Type": "multipart/form-data",
        },
      }
    ).then(response => response)
  );

  return result;
};

export const GetMTDAchievementDetails = async (partnerCode, month,year) => {
    //debugger;
    var result = await trackPromise(axios.get(CommonVariables.API_DOMAIN + `MetLink/Get_MTD_Achievement_Details?partner_code=${partnerCode}&month=${month}&year=${year}`, CommonVariables.API_HEADER)).then(response => response);
    return result;
}

export const GetSPOC_Details_ByPartnerCode = async (partnerCode, month,year) => {
    //debugger;
    var result = await trackPromise(axios.get(CommonVariables.API_DOMAIN + `MetLink/GetSPOC_Details_ByPartnerCode?partnerCode=${partnerCode}`, CommonVariables.API_HEADER)).then(response => response);
    return result;
}

export const UploadMonthlyExcel = async (formData) => {
  const result = await trackPromise(
    axios.post(
      CommonVariables.API_DOMAIN + `MetLink/Upload_Monthly_Achievement_Excel`,
      formData,
      {
        ...CommonVariables.API_HEADER,
        headers: {
          ...CommonVariables.API_HEADER.headers,
          "Content-Type": "multipart/form-data",
        },
      }
    ).then(response => response)
  );

  return result;
};

export const GetMonthlyAchievementDetails = async (partnerCode, month, year, reportType) => {
    var result = await trackPromise(axios.get(CommonVariables.API_DOMAIN + `MetLink/Get_Monthly_Achievement_Details?partner_code=${partnerCode}&month=${month}&year=${year}&reportType=${reportType}`, CommonVariables.API_HEADER)).then(response => response);
    return result;
}

export const GetPartnerList = async (businessType) => {

    const result = await trackPromise(
        axios.get(
            `${CommonVariables.API_DOMAIN}MetLink/Get_Partner_List?businessType=${businessType}`,
            CommonVariables.API_HEADER
        )
    ).then(response => response);

    return result;
}

export const UploadRecoExcel = async (formData) => {
  const result = await trackPromise(
    axios.post(
      CommonVariables.API_DOMAIN + `MetLink/Upload_Reco_Excel`,
      formData,
      {
        ...CommonVariables.API_HEADER,
        headers: {
          ...CommonVariables.API_HEADER.headers,
          "Content-Type": "multipart/form-data",
        },
      }
    ).then(response => response)
  );

  return result;
};

export const GetRecoDetails = async (partnerCode, month, year) => {
    //debugger;
    var result = await trackPromise(axios.get(CommonVariables.API_DOMAIN + `MetLink/Get_Reco_Details?partner_code=${partnerCode}&month=${month}&year=${year}`, CommonVariables.API_HEADER)).then(response => response);
    return result;
}